import { Navigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { locations } from 'services/routes/locations';

export default function NoRouteMatched() {
  if (isMobile) {
    return <Navigate to={locations.general.discovery.pathname} />;
  }

  return <Navigate to={locations.other.blankPage.pathname} />;
}
